<template>
  <div class="row d-flex flex-column margin-top-20" dir="rtl">
    <div class="d-flex arrow-margin">
      <div v-if="content.title" class="f22-l30-b df36-l30-b">
        {{content.title}}
      </div>
    </div>
    <div class="margin-top-20">
      <HorizontalScrollContainer>
        <div v-for="(pbox,idx) in content.boxes" :key="idx" class="position-relative"  style="margin-left:10px; display: inline-block">
          <ImgImage :img="$responsive(pbox.box.image)" @click="navigateTo(pbox.box.href, pbox.box.data_layer)" class="pointer" />
          <div class="f18-l20-b cff text-wrap position-absolute" style="bottom:0px; right: 10px; height: 2.5em; max-width: 60%;">{{pbox.box.title}}</div>
        </div>
      </HorizontalScrollContainer>
    </div>
  </div>
</template>
<script>
import ImgImage from "@/components/generic/ImgImage.vue";
import HorizontalScrollContainer from "@/components/generic/HorizontalScrollContainer.vue";
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';

export default {
  components: {
    ImgImage,
    HorizontalScrollContainer
  },
  props: {
    content: Object
  },
  methods: {
    navigateTo(loc, data_layer) {
      // Trigger Google Tag Manager event
      addGoogleAnalyticsDataLayer(data_layer);
      // console.log(loc);
      // Add a delay to ensure GTM captures the event before navigation
      setTimeout(() => {
        if (loc.startsWith('popup:')) {
          this.$store.dispatch('showPopupWithUrl', loc.substring(6), 'bottom');
          return;
        }
        if (loc.startsWith('http')) {
          window.location = loc;
          return;
        }
        this.$router.push(loc);
      }, 100);
    }
  }
}
</script>
<style scoped>
@media (min-width: 1200px) {
  .arrow-margin {
    padding-left: 45px;
    padding-right: 45px;
  }
}
</style>